// extracted by mini-css-extract-plugin
module.exports = {"postBody":"post-module--post-body--3Qb5g"};